<iw-shop-forms-error [apiError]="apiError"></iw-shop-forms-error>
<div [formGroup]="form">
    <div class="columns-customer-data is-marginless columns is-multiline">
        <div class="column is-6 is-12-mobile">
            <div class="field ">
                <label class="label">Kunden-Nr.:</label>
                <div class="control">
                    <input
                            formControlName="customerNumber"
                            class="input is-disabled"
                            type="text"
                            placeholder="Kunden-Nr."/>
                </div>
            </div>
        </div>
        <div class="column is-6 is-12-mobile">
            <div class="field field-customer-price-group">
                <label class="label">Preisgruppe:</label>
                <div class="control">
                    <input
                            formControlName="priceGroup"
                            class="input"
                            type="text"
                            placeholder="Preisgruppe"/>
                </div>
            </div>
        </div>
        <div class="column is-6 is-12-mobile">
            <div class="field ">
                <label class="label">Preismodus:</label>
                <div class="control">
                    <div class="select is-block">
                        <select formControlName="priceMode">
                            <option value="net">Netto</option>
                            <option value="gross">Brutto</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="mt-4" [ngClass]="da.dynamicArticles.length > 0 ? '': 'is-hidden'">
                <iw-shop-customer-dynamic-articles #da (onChangeCustomerDynamicArticleIds)="form.get('dynamicArticleIds')?.setValue($event)"></iw-shop-customer-dynamic-articles>
            </div>
        </div>
        <div class="column is-6 is-12-mobile">
            <div class="field">
                <label class="label">Geburtsdatum</label>
                <p-datepicker
                    #datePicker
                    (onShow)="selectYear()"
                    formControlName="dateOfBirth"
                        [defaultDate]="dateOfBirthMax"
                        [showIcon]="true"
                        [readonlyInput]="true"
                        [minDate]="dateOfBirthMin"
                        [maxDate]="dateOfBirthMax"
                        ariaLabel="Geburtsdatum"
                        dataType="date"
                        dateFormat="dd.mm.yy"

                ></p-datepicker>

                <p *ngIf="isFormRequestError('dateOfBirth')" class="help is-danger">Bitte hinterlegen Sie ein
                    Geburtsdatum.</p>
            </div>
        </div>
        <div class="column is-12">
            <iw-shop-forms-submit-button [formStatus]="formStatus" [submitLabel]="'Speichern'"
                                         (submit)="submit()"></iw-shop-forms-submit-button>
            <div class="border-bottom p-4"></div>
        </div>
        <div class="container-address-overview column is-12">
            <div class="border-bottom p-4">
                <div class="columns">
                    <div class="column">
                        <iw-shop-customer-addresses-overview addressVisibility="billing"
                                                             [visibilityNewButton]="true"></iw-shop-customer-addresses-overview>
                    </div>
                    <div class="column">
                        <iw-shop-customer-addresses-overview addressVisibility="delivery"
                                                             [visibilityNewButton]="true"></iw-shop-customer-addresses-overview>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
